export function mapProjectInfoToGanttStoreProperties(projectInfo, globalProjectData={}) {
  const projectData = projectInfo.Project

  return {
    BasisTime: new Date(projectData[0]),
    StartDate: new Date(projectData[1]),
    EndDate: new Date(projectData[2]),
    DisplayedStartDate: new Date(projectData[3]),
    DisplayedEndDate: new Date(projectData[4]),
    ProjectName: projectData[5],
    Comment: projectData[6],
    StyleObjects: projectData[7],
    CurrentStyle: projectData[7][0],
    ValidStartDate: new Date(projectData[8]),
    ValidEndDate: new Date(projectData[9]),
    LastUploadTimestamp: projectInfo.UploadTimeStamp,
    LastTransactionDownloadTimestamp: projectInfo.LastDownloadTimeStamp,
    CurrentDisplayedStartDate: new Date(projectData[3]) > new Date(projectData[8]) ? new Date(projectData[3]) : new Date(projectData[8]),
    DayStartTime: globalProjectData?.Project_DayStartTime || "00:00:00",
    OtherDemarcationTimes: globalProjectData?.Project_OtherDemarcationTimes || [],
    HolidayDates: globalProjectData?.Holidays?.Dates?.map((d) => new Date(d)) || []
  }
}
